const ZUSE_PUBLIC_HOSTS = new Set(["zusedigital.com", "stagingdev.zusedigital.com"]);

export function stripWwwFromZuseHostname(hostname) {
  if (!hostname || !hostname.startsWith("www.")) return hostname;
  const bare = hostname.slice(4);
  return ZUSE_PUBLIC_HOSTS.has(bare) ? bare : hostname;
}

export function normalizeZuseSiteUrl(url) {
  const input = String(url || "").trim();
  if (!input) return input;

  try {
    const parsed = new URL(input);
    parsed.hostname = stripWwwFromZuseHostname(parsed.hostname);
    return parsed.toString().replace(/\/+$/, "");
  } catch {
    return input.replace(/\/+$/, "");
  }
}
